export default "__VITE_ASSET__MoDhizRV__"